// eslint-disable-next-line no-undef
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// eslint-disable-next-line no-undef
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLEMAP_API_KEY;
